import React from "react";
import { useDropzone } from "react-dropzone";
import uploadIcon from "@src/assets/svg/new-upload-icon.svg";
import deleteGrayIcon from "@src/assets/svg/delete-gray-icon.svg";
import styles from "./private-key-upload-field.module.scss";
import { IconButton } from "../buttons/icon-button/icon-button";

const cssClassName = "private-key-upload-field";

interface PrivateKeyUploadFieldProps {
  label: string;
  fileName: string;
  onFileSelect: (file: File | null) => void;
}

export const PrivateKeyUploadField = ({
  label,
  fileName,
  onFileSelect,
}: PrivateKeyUploadFieldProps) => {
  const hasSelectedFile = Boolean(fileName);

  const { getRootProps, getInputProps, isDragAccept, isDragReject } =
    useDropzone({
      onDrop: (acceptedFiles) => {
        onFileSelect(acceptedFiles[0] ?? null);
      },
    });

  const handleDeleteSelectedFile = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    event.stopPropagation();
    onFileSelect(null);
  };

  const uploadAreaClasses = [
    styles[`${cssClassName}__upload-area`],
    isDragAccept ? styles[`${cssClassName}__upload-area--accept`] : "",
    isDragReject ? styles[`${cssClassName}__upload-area--reject`] : "",
  ]
    .filter(Boolean)
    .join(" ");

  const uploadTextClasses = [
    styles[`${cssClassName}__upload-text`],
    !hasSelectedFile ? styles[`${cssClassName}__upload-text--placeholder`] : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__label`]}>{label}</p>

      <div
        {...getRootProps({
          className: uploadAreaClasses,
        })}
      >
        <input {...getInputProps()} />
        <div className={styles[`${cssClassName}__upload-content`]}>
          <IconButton
            fun={() => ({})}
            icon={uploadIcon}
            aria-label="Upload private key file"
          />
          <span className={uploadTextClasses}>{fileName || "Choose file"}</span>
        </div>

        {hasSelectedFile && (
          <button
            type="button"
            className={styles[`${cssClassName}__delete-button`]}
            onClick={handleDeleteSelectedFile}
            aria-label="Delete selected private key file"
          >
            <img src={deleteGrayIcon} alt="Delete" width={16} height={16} />
          </button>
        )}
      </div>
    </div>
  );
};
